import React from 'react';
import LegalPage from '../components/LegalPage';

const Security = () => (
  <LegalPage
    title="Security"
    description="How to responsibly report a security vulnerability in AVbot, plus scope and safe harbor."
    file="security.md"
  />
);

export default Security;
